import { render, staticRenderFns } from "./LoadProfileSettings.vue?vue&type=template&id=07324aa3&scoped=true"
import script from "./LoadProfileSettings.vue?vue&type=script&lang=js"
export * from "./LoadProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./LoadProfileSettings.vue?vue&type=style&index=0&id=07324aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07324aa3",
  null
  
)

export default component.exports